import Vue from "vue"
import router from "./router"
import store from "./store"
import VueMeta from "vue-meta"
import Element from "element-ui"

import VueSuperSlide from 'vue-superslide'
Vue.use(VueSuperSlide)

import {
  Message
} from 'element-ui'

let messageInstance = null;
const overrideMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }
    messageInstance = Message(options)
}
['error','success','info','warning'].forEach(type => {
    overrideMessage[type] = options => {
        if(typeof options === 'string') {
            options = {
                message:options
            }
        }
        options.type = type
        return overrideMessage(options)
    }
})
Vue.use(Element)
Vue.prototype.$message = overrideMessage;

import scroll from 'vue-seamless-scroll'

import "element-ui/lib/theme-chalk/index.css"
import "./assets/styles/main.scss"
import "./assets/styles/element-variables.scss"

import VideoPlayer from "vue-video-player"
import "video.js/dist/video-js.css"

import App from "./App.vue"

import Util from "./utils/util"
import Lang from "./utils/lang.js"
import Config from "./utils/config.js"

// jquery
import $ from 'jquery'
Vue.prototype.$ = $;

Vue.prototype.$store = store //挂在vue
Vue.config.productionTip = false

// 常用工具函数
Vue.prototype.$util = Util
Vue.prototype.$img = Util.img
Vue.prototype.$timeStampTurnTime = Util.timeStampTurnTime
Vue.prototype.$copy = Util.copy
window.util = Util
window.img = Util.img
window.timeStampTurnTime = Util.timeStampTurnTime
window.copy = Util.copy

// 语言包
Vue.prototype.$langConfig = Lang //语言包对象
Vue.prototype.$lang = Lang.lang //解析语言包
window.langConfig = Lang
window.lang = Lang.lang

Vue.prototype.$config = Config

Vue.use(VideoPlayer)
Vue.use(VueMeta)
Vue.use(scroll)

window.vue = new Vue({
    router,
    store,
    metaInfo() {
        return {
            //title: store.getters.siteInfo.title || "三农网",
            meta: [
                { name: "title", content: "三农网 — 助您的产品走向世界！三农网，农业信息，农业政策，农产品批发，农村合作社，种植技术，养殖技术，农资价格，农业电子商务，最权威的农业信息化平台！" },
                { name: "desc", content: "三农网，最权威的农业信息化平台，为您提供最有价值的农业信息、农资价格；最新的农业政策；最全面的农业种植及养殖技术；农产品在线批发、销售； 为您提供极致的农业及周边服务。找最权威的农业信息化平台，就找三农网！" },
                { name: "keywords", content: "三农网，三农,农业信息，农业政策，农村合作社，种植技术，农产品批发市场,养殖技术，农资价格，农业电商，农业电子商务，农产品批发，农业信息化，农业资讯" }
            ]
        }
    },
    render: h => h(App)
}).$mount("#app")

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

